export enum ActionTypes {
  UpdatePlan = 'updatePlan',
  UpdatePlanRequest = 'updatePlan.request',
  UpdatePlanSuccess = 'updatePlan.success',
  UpdatePlanFailure = 'updatePlan.failure',

  ClearUpdatePlanServerErrors = 'clearUpdatePlanServerErrors',
}
